module.exports = __webpack_public_path__ + "js/cutie.45b4c23e.worker.js"